import { ServerInfo, registerServers } from '../base';
import { addon, Application, log } from 'pao-aop';

/**
 * 主应用程序
 */
export let mainApplication: ServerApplication;

/**
 * 服务应用
 * @author pao
 */
@addon('ServerApplication', '服务应用设置', '包含各种资源的主服务应用实体对象')
export class ServerApplication extends Application {
    /**
     * 服务应用设置
     * @param services 服务列表
     * @param servers 服务器列表
     */
    constructor(
        public servers?: ServerInfo[]) {
        super();
    }

    /**
     * 运行服务器
     */
    runServers?(): void {
        if (this.servers) {
            registerServers(this.servers);

            for (let server of this.servers!) {
                server.serverObject!.start!();
            }
        }
    }

    /**
     * 启动应用
     */
    protected startApplication?(): void {

    }

    /**
     * 初始化
     */
    protected onInit?(): void {

    }

    /**
     * 运行
     */
    protected onAppStart?(): void {
        super.onAppStart();
        mainApplication = this;
        this.onInit();
        log('app', '开始启动服务器');
        this.runServers!();
        log('app', '开始启动应用程序');
        this.startApplication!();
    }
}